"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _hadate = require("../../helpers/hadate");

var _getToday = _interopRequireDefault(require("../../helpers/hadate/getToday"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(startDate, endDate) {
  var today = (0, _getToday["default"])();
  var diffTodayStart = (0, _hadate.diffDay)(today, startDate);
  var diffTodayEnd = (0, _hadate.diffDay)(today, endDate);

  if (diffTodayStart < 0) {
    return {
      from: today,
      to: (0, _hadate.addDays)(startDate, -1)
    };
  }

  if (diffTodayEnd >= 0) {
    return {
      from: _hadate.NO_START,
      to: _hadate.NO_END
    };
  }

  return {
    from: _hadate.NO_START,
    to: _hadate.NO_START
  };
};

exports["default"] = _default;